import { colorPrimary } from '@atlas-frontend/design-tokens';
import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

export interface TextBadgeProps {
  color?: string;
}

export const TextBadge: FC<PropsWithChildren<TextBadgeProps>> = ({
  children,
  color = colorPrimary,
}) => {
  return <Wrapper $color={color}>{children}</Wrapper>;
};

const Wrapper = styled.span<{ $color?: string }>`
  justify-content: center;
  margin-block: -1px;
  vertical-align: baseline;

  min-width: 20px;
  height: 20px;
  color: ${({ $color }) => $color};
  line-height: 1;
  white-space: nowrap;
  text-align: center;
  border-radius: calc(20px / 2);
  border-width: 1px;
  border-style: solid;
  border-color: ${({ $color }) => $color};
  padding: 1px 4px;
`;
